import type { CheckoutDinnerVouchersOption, CheckoutDinnerVouchersService } from '@/scopes/checkout/domain/types'

/**
 * Returns the currently selected dinner voucher option, or null if none is selected.
 */
export function getSelectedOption(
  service: CheckoutDinnerVouchersService,
): CheckoutDinnerVouchersOption | null {
  if (!service.selectedValue)
    return null

  return service.options.find(o => o.value === service.selectedValue) ?? null
}

/**
 * Returns the price for the currently selected option, or 0 if nothing is selected.
 */
export function getSelectedOptionPrice(service: CheckoutDinnerVouchersService): number {
  const option = getSelectedOption(service)
  return option?.rawPrice ?? option?.price ?? 0
}

/**
 * Returns total price: selectedQuantity × option price.
 * Returns 0 when no option is selected.
 */
export function getTotalPrice(service: CheckoutDinnerVouchersService): number {
  const optionPrice = getSelectedOptionPrice(service)
  return optionPrice * service.selectedQuantity
}
